import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInitialState } from './summarySlice';
import Loader from '../../components/loader';
import { StepHeading, StepShell } from '../../components/optionCard';
import { jumpToStep } from '../FormNavigator/navigatorSlice';
import { RenderSlidePreview } from './utils';
import { BDS_TEAM_LEAD_TITLE, isRizeForRealtorFlow } from '../../config/flows';

const DATA_MAPPING = {
    '1' : { 'data': 'manager', 'title': 'Branch Manager Details'},
    '2' : { 'data': 'employees',  'title': 'Branch Employee Details'},
    '3' : {'data': 'license_states',   'title': 'Requested States to be Licensed in'},
    // '4' : reserved (Branch Location Type) — kept for future client use
    '5' : { 'data': 'processing_plan',   'title': 'Processing Plan'},
    '6' : { 'data': 'margin_management',   'title': 'Margin Management'},
    '7' : { 'data': 'branch_location',   'title': 'Branch Location Option'},
    '8' : { 'data': 'branch_location',   'title': 'Branch Location Details'},
    '9' : { 'data': 'branch_location',   'title': 'Services And Utilities'},
    '10' : { 'data': 'locking_cabinet',   'title': 'Micro Cut Shredder'},
    '11' : {  'data': 'locking_cabinet',  'title': 'Locking File Cabinet'},
    '12' : { 'data': 'local_it_company',   'title': 'Local IT Company Details'},
    '13' : { 'data': 'office_space',   'title': 'Office Space Information'},
    '14' : { 'data': 'office_space',   'title': 'Office Space Details'},
    '15' : { 'data': 'mortgage_sign',   'title': 'Mortgage Sign Details'},
    '16' : { 'data': 'compliance_signage',   'title': 'Compliance Signage Details'},
    '17' : { 'data': 'occupational_license',   'title': 'Occupational License Details'},
    '18' : { 'data': 'marketing_details',   'title': 'Existing Marketing'},
}

const Summary = () => {
    const dispatch = useDispatch();
    const summaryState = useSelector((state) => state.summary);
    const navigatorState = useSelector(state => state.navigator)
    const [objectKeys, setObjectKeys] = useState(["1", "2", "3", "5", "6", "7", "18"]);

    // Rize for Realtor team: step 1 is the Business Development Team Lead's details,
    // not a Branch Manager's.
    const isRizeTeam = isRizeForRealtorFlow(navigatorState.linkMeta?.newType);
    const sectionTitle = (key) => (
        (key === '1' && isRizeTeam) ? `${BDS_TEAM_LEAD_TITLE} Details` : DATA_MAPPING[key].title
    );

    useEffect(() => {
        dispatch(fetchInitialState())
    }, [dispatch]);

    useEffect(() => {
        if (summaryState.data?.branch_location?._option === 'Existing Location with Lease'
            || summaryState.data?.branch_location?._option === 'Existing Location without Lease') {
            setObjectKeys(Object.keys(DATA_MAPPING))
        }
    }, [summaryState.data?.branch_location?._option])



    return (
    <>
        { ( summaryState.loading || navigatorState.loading ) && <Loader /> }
        <StepShell className="mb-10">
            <StepHeading>
                Summary
            </StepHeading>

            <div className="mx-auto mt-8 w-full max-w-3xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm sm:mt-10">
            <div className="p-3 sm:p-5">
                <div className="mt-2 flex flex-col">
                    {objectKeys.map((item, index) => (
                        <div key={index}>
                                <div key={index} className="border-b border-slate-200 pb-4 last:border-b-0">
                                    <div className='flex items-start justify-between gap-3 py-2'>
                                        <span className="text-sm font-bold text-[#211b4f] sm:text-base">
                                            {sectionTitle(item)}
                                        </span>
                                        <button
                                        className="inline-flex h-9 w-9 flex-none items-center justify-center rounded-lg text-[#fb6635] transition-colors hover:bg-orange-50"
                                        onClick={() => dispatch(jumpToStep({step: parseInt(item.split('__')[0])}))}
                                        >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                            <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                                        </svg>
                                    </button>
                                        
                                    </div>
                                    <div >
                                        {Object.keys(summaryState.data).length > 0 && ( 
                                            <RenderSlidePreview 
                                                slide={item} 
                                                data={summaryState.data[DATA_MAPPING[item].data]} 
                                        /> )}
                                    </div>
                                </div>
                        </div>
                    ))}
                </div>
            </div>
            </div>
        </StepShell>
    
    </>
  )
}

export default Summary;
